import { useEffect, useState } from "react";
import { FieldParams } from "./FieldObject";
import {
  DeepMergeObject,
  DotStringToObject,
  getCellStyle,
  GetHeaderStyle,
} from "./Helper";
import {
  FieldDataType,
  FormCancleClick,
  FormControlType,
  getCommalessNumber,
  getDecimalString,
} from "./Helper2";

export const PaymentMethod = [
  { PayMethodId: 0, PayMethodName: "*** เลือกวิธีชำระ **", suffix: "-" },
  { PayMethodId: 1, PayMethodName: "เงินสด", suffix: "-" },
  { PayMethodId: 2, PayMethodName: "เงินโอน", suffix: "สลิปโอน" },
  { PayMethodId: 3, PayMethodName: "เช็คธนาคาร", suffix: "เช็ค" },
  {
    PayMethodId: 4,
    PayMethodName: "ตัดบัตรเครดิต",
    suffix: "บัตรเครดิต",
  },
];

export const GetReceipteHeaderObject = (props) => {
  const { doculist, onSelectDocument, docuFieldIdName, head, custClick } =
    props;

  const cancleClick = (item, setObject) => {
    if (!setObject) return;
    setObject((pv) => ({
      ...pv,
      ...DeepMergeObject(
        DotStringToObject(item.fieldName + "." + item.searchValueName, 0),
        DotStringToObject(item.fieldName + "." + item.searchDisplayName, null)
      ),
    }));
  };
  return {
    [docuFieldIdName]: {
      ...new FieldParams(
        docuFieldIdName,
        "DocuId",
        true,
        FieldDataType.NUMERIC,
        FormControlType.HIDDEN
      ),
    },

    BranchDocu: {
      ...new FieldParams(
        "DocuBranch",
        "ประเภทเอกสาร",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SELECT
      ),
      selectData: doculist,
      selectHasFirstOption: false,
      selectBuildObjectPath: "DocuBranch.BranchDocu",
      selectValueName: "DocuBrchId",
      selectDisplayName: "DocuType.DocuTypeName", // [docuList].DocuType.DocuTypeName
      onChange: onSelectDocument,
      disabled: head?.[docuFieldIdName] ? true : false,
    },
    DocuNo: {
      ...new FieldParams(
        "DocuNo",
        "เลขที่เอกสาร",
        true,
        FieldDataType.TEXT,
        null,
        head?.DocuNo ?? null
      ),
      disabled: head?.[docuFieldIdName] ? true : false,
    },
    DocuDate: {
      ...new FieldParams(
        "DocuDate",
        "วันที่เอกสาร",
        true,
        FieldDataType.DATE,
        FormControlType.DATE_PICKER
      ),
      disabled: head?.[docuFieldIdName] ? true : false,
    },

    Customer: {
      ...new FieldParams(
        "Customer",
        "ตั้งเบิกกับ",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "Customer.CustShortName",
      searchDisplayName: "CustShortName",
      searchValueName: "CustId",
      searchButtonClick: custClick,
      searchCancelClick: cancleClick,
      //labelStyle: { minWidth: "100px", flex: "none" },
    },

    BillTo: new FieldParams("BillTo", "ออกให้กับ", null, null, null),
    Addr1: new FieldParams("BillAddr1", "ที่อยู่", null, null, null),
    Addr2: new FieldParams("BillAddr2", "", null, null, null),
    Phone: new FieldParams("BillPhone", "เบอร์โทร", null, null, null),
  };
};

export const GetReceiptFooterObject = (props) => {
  const {
    onChangeDiscount,
    onChangeHoldTaxRate,
    onChangeHoldTaxTotal,
    onSelectPaymentMethod,
    summary,
  } = props;

  return {
    Amount: {
      ...new FieldParams(
        "Amount",
        "ยอดรวม",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      readOnly: true,
    },
    Discount: {
      ...new FieldParams(
        "Discount",
        "ส่วนลด",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL
      ),
      readOnly: false,
      // onChange: onChangeDiscount ?? null,
    },
    Total: {
      ...new FieldParams(
        "Total",
        "รวม",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      readOnly: true,
    },
    VatRate: {
      ...new FieldParams(
        "VatRate",
        "อัตราภาษี",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
        // summary?.VatRate ?? 0
      ),
      readOnly: true,
    },
    VatTotal: {
      ...new FieldParams(
        "VatTotal",
        "ยอดรวมภาษี",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
        // summary?.VatTotal ?? 0
      ),
      readOnly: true,
    },
    NetTotal: {
      ...new FieldParams(
        "NetTotal",
        "รวมทั้งสิ้น",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
        // summary?.NetTotal
      ),
      readOnly: true,
    },
    HoldingTaxRate: {
      ...new FieldParams(
        "HoldingTaxRate",
        "อัตราหัก ณ ที่จ่าย",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
        // summary?.HoldingTaxRate ?? 0
      ),
      readOnly: false,
      onChange: onChangeHoldTaxRate,
    },
    HoldingTaxAmount: {
      ...new FieldParams(
        "HoldingTaxAmount",
        "ภาษีหัก ณ ที่จ่าย",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
        // summary?.HoldingTaxAmount
      ),
      readOnly: false,
      onChange: onChangeHoldTaxTotal,
    },
  };
};

export const GetReceiptPaymentObject = (props) => {
  // if (IsEmptyObject(props)) return;

  const { bankClick, data, renderHeader, payMedthodChanged } = props;

  // console.log("Check income data", data);

  let payMethodId = data?.PayMethod?.PayMethodId ?? 1;

  let suffixText = PaymentMethod[Number(payMethodId)]?.suffix;

  return {
    ReceiptPaymentId: {
      ...new FieldParams(
        "ReceiptPaymentId",
        "",
        true,
        FieldDataType.NUMERIC,
        FormControlType.HIDDEN
      ),
      isHiddenColumn: true,
      filter: undefined,
    },
    PayMethod: {
      ...new FieldParams(
        "PayMethod",
        "วิธีชำระ",
        true,
        FieldDataType.TEXT,
        FormControlType.SELECT
      ),
      defaultHeaderStyle: GetHeaderStyle("150px"),
      defaultCellStyle: getCellStyle("center"),
      tableColumnFieldName: "PayMethod.PayMethodName",
      selectData: PaymentMethod,
      selectHasFirstOption: false,
      selectValueOnly: false,
      selectValueName: "PayMethodId",
      selectDisplayName: "PayMethodName",
      filter: undefined,
      onChange: payMedthodChanged,
    },
    ChqNo: {
      ...new FieldParams(
        "ChqNo",
        !renderHeader && payMethodId > 1
          ? "เลขที่" + suffixText
          : "เลขที่เช็ค/สลิป"
      ),
      defaultHeaderStyle: GetHeaderStyle("200px"),
      readOnly: Number(data?.PayMethod?.PayMethodId) === 1,
    },
    ChqBank: {
      ...new FieldParams(
        "ChqBank",
        // "เช็คธนาคาร",
        !renderHeader && payMethodId > 1 ? suffixText + "ธนาคาร" : "ธนาคาร",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "ChqBank.BankShort",
      searchDisplayName: "BankShort",
      searchValueName: "BankId",
      searchDisplayDefault: "--",
      searchButtonClick: bankClick,
      searchCancelClick: FormCancleClick,
      readOnly: Number(data?.PayMethod?.PayMethodId) === 1,
      // labelStyle: { minWidth: minWidth, flex: "none" },
    },
    ChqDate: {
      ...new FieldParams(
        "ChqDate",
        // "วันที่เช็ค",
        !renderHeader && payMethodId > 1
          ? "วันที่" + suffixText
          : "วันที่เช็ค/สลิป",
        false,
        FieldDataType.DATE,
        FormControlType.DATE_PICKER
      ),
      readOnly: Number(data?.PayMethod?.PayMethodId) === 1,
    },
    ChqValidDate: {
      ...new FieldParams(
        "ChqValidDate",
        "วันที่ได้รับเงิน",
        false,
        FieldDataType.DATE,
        FormControlType.DATE_PICKER
      ),
      readOnly: Number(data?.PayMethod?.PayMethodId) === 1,
    },
    Amount: {
      ...new FieldParams(
        "Amount",
        "จำนวนเงิน",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL
      ),
      defaultCellStyle: getCellStyle("right"),
      defaultHeaderStyle: GetHeaderStyle("100px", "right"),
      labelStyle: { width: "200px", flex: "none" },
    },
  };
};

/**
 * คำนวณ Vat นอก
 * @param {*} amount
 * @param {*} vatRate
 * @param {*} holdingTaxRate
 * @param {*} stateSum
 */
export const CalcSumVatExclude = (
  amount,
  vatRate,
  holdingTaxRate,
  stateSum
) => {
  const [sum, setSum] = stateSum;

  sum.Amount = getDecimalString(amount, 2);
  let total = getCommalessNumber(sum.Amount) - getCommalessNumber(sum.Discount);
  sum.Total = getDecimalString(total, 2);

  let vatTotal = total * getCommalessNumber(vatRate);
  let netTotal = Number(total) + Number(vatTotal);

  let holdingTaxAmount = netTotal * holdingTaxRate;
  sum.VatRate = getDecimalString(vatRate);
  sum.VatTotal = getDecimalString(vatTotal);
  sum.NetTotal = getDecimalString(netTotal);
  sum.HoldingTaxAmount = getDecimalString(holdingTaxAmount);

  setSum(sum);
};

/**
 * Vat ใน
 * @param {*} amount
 * @param {*} vatRate
 * @param {*} holdingTaxRate
 * @param {*} stateSum
 */
export const CalcSumVatInclude = (
  amount,
  vatRate,
  holdingTaxRate,
  stateSum
) => {
  const [sum, setSum] = stateSum;

  sum.Amount = getDecimalString(amount, 2);
  let total = getCommalessNumber(sum.Amount) - getCommalessNumber(sum.Discount);

  let vatTotal = total * ((vatRate * 100) / (100 + vatRate * 100));

  let netTotal = Number(amount) - vatTotal;

  sum.Total = getDecimalString(netTotal, 2);

  let holdingTaxAmount = netTotal * holdingTaxRate;
  sum.VatRate = getDecimalString(vatRate, 2);
  sum.VatTotal = getDecimalString(vatTotal, 2);
  sum.NetTotal = getDecimalString(total, 2);
  sum.HoldingTaxAmount = getDecimalString(holdingTaxAmount, 2);
  setSum(sum);
};
